// 路由前置守卫
export function initGuard(router) {
    router.beforeEach((to, from, next) => {
        // 设置title
        if(to.meta.title) {
            document.title = to.meta.title
        }
        next()
    })
}